import React, { useEffect } from "react";
import "./App.scss";
import { Route, Routes, useNavigate } from "react-router-dom";
import { ConfigProvider } from "./providers/ConfigContext";
import LandingPage from "./pages/landingpage/LandingPage";
import CreditReview from "./pages/Credit/creditreview/CreditReview";
import parseQueryParams from "./utils/query-params";
import CreditConfirmation from "./pages/Credit/creditconfirmation/CreditConfirmation";
import EwalletRefundSale from "./pages/Refund/ewalletrefundsale/EwalletRefundSale";
import EwalletRefundReview from "./pages/Refund/ewalletrefundreview/EwalletRefundReview";
import EwalletPaymentReview from "./pages/Ewallet/ewalletpaymentreview/EwalletPaymentReview";
import DisplayEwallets from "./pages/DisplayEwallets/DisplayEwallets";
import CreditForm from "./pages/Credit/creditform/CreditForm";
import AuthGuard from "./services/authguard/authGuardService";
import RedeemStf from "./pages/RedeemSTF/RedeemSTF";

function App() {
  const { fairId, walletId, iamId } = parseQueryParams(window.location);
  
  return (
    <ConfigProvider>
      <Routes>
        <Route path="/success" element={<LandingPage />} />
        <Route path="/creditcardpayment.html" element={<AuthGuard component={<CreditForm version="creditcard" />} />} />
        <Route path="/creditcardpayment/review.html" element={<AuthGuard component={<CreditReview version="creditcard" />} />} />
        <Route path="/creditcardpayment/confirmation.html" element={<AuthGuard component={<CreditConfirmation version="creditcard"/>} />} />
        <Route path="/ewalletpayment.html" element={<AuthGuard component={<DisplayEwallets redirectFunc="payment" fairId={fairId} />} />} />
        <Route path="/ewalletpayment/amount.html" element={<AuthGuard component={<EwalletPaymentReview walletId={walletId} />} />} />
        <Route path="/ewalletrefund.html" element={<AuthGuard component={<DisplayEwallets redirectFunc="refund" fairId={fairId} />} />} />
        <Route path="/ewalletrefund/sales.html" element={<AuthGuard component={<EwalletRefundSale />} />} />
        <Route path="/ewalletrefund/review.html" element={<AuthGuard component={<EwalletRefundReview />} />} />
        <Route path="/remitpayment.html" element={<AuthGuard component={<CreditForm version="remit" />} />} />
        <Route path="/remitpayment/review.html" element={<AuthGuard component={<CreditReview version="remit" />} />} />
        <Route path="/remitpayment/confirmation.html" element={<AuthGuard component={<CreditConfirmation version="remit"/>} />} />
        <Route path="/sharethefair.html" element={<AuthGuard component={<RedeemStf/>} />} />

        <Route path="" element={<LandingPage fairId={fairId} idamId={iamId} />} />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
